import * as Yup from 'yup';

// Mirrors SafeDisplayTextAttribute on the API. Keeps ':' and '/' out of the names that get
// reflected back to users in email, so a display name cannot arrive as a working link.
export const SAFE_DISPLAY_TEXT_PATTERN = /^[\p{L}\p{N} .,'&()-]+$/u;

export const SAFE_DISPLAY_TEXT_MESSAGE =
  "Only letters, numbers, spaces and the characters . , ' & ( ) - are allowed";

export const NAME_MAX_LENGTH = 100;
export const COMPANY_NAME_MAX_LENGTH = 200;

export const displayTextValidation = (label, maxLength = NAME_MAX_LENGTH) =>
  Yup.string()
    .trim()
    .max(maxLength, `${label} must be ${maxLength} characters or fewer`)
    .matches(SAFE_DISPLAY_TEXT_PATTERN, SAFE_DISPLAY_TEXT_MESSAGE)
    .required(`${label} is required`);
